import { ISidebarProps } from '@/types';
import { cn } from '@/lib/utils';
import React from 'react';
import { NavLink, useLocation } from 'react-router';

export const SubSideBarItem: React.FC<{ item: ISidebarProps }> = ({ item }) => {
  const location = useLocation();
  const Icon = item.icon;
  const isActive = location.pathname.includes(item.target);

  return (
    <li className="list-none">
      <NavLink
        className={cn(
          'flex items-center gap-3 rounded-lg px-3 py-2 text-sm transition-all duration-200',
          isActive
            ? 'bg-primary-50 font-medium text-primary-700'
            : 'text-coal-500 hover:bg-coal-100 hover:text-coal-700'
        )}
        to={item.target}
      >
        <span className={cn(
          'flex h-4 w-4 items-center justify-center transition-colors',
          isActive ? 'text-primary' : 'text-coal-400'
        )}>
          {Icon && <Icon />}
        </span>
        <span>{item.title}</span>
      </NavLink>
    </li>
  );
};
